<template>
    <v-app-bar app absolute="false" :color="appColor" dark height="200px"
        src="../../../assets/backgrounds/kings_campus.png">
    </v-app-bar>
</template>

<script>
export default {
    name: 'parent-approval-toolbar'
}
</script>